import { z } from "zod";

/**
 * Weight Health validation schema
 * Validates the entire weightHealth category
 */

export const weightHealthValidation = z.object({
  botheredByWeight: z.string().min(1, "Please select an option"),
  discussWeight: z.boolean(),
  weightLossMethods: z.array(z.string()).optional(),
  eatingDisorder: z.boolean().optional(),
  pregnant: z.boolean().optional(),
  pregnantPlanning: z.boolean().optional(),
});

export default weightHealthValidation;
